package com.happyukrainian.revision.kweb

import androidx.compose.runtime.*
import com.happyukrainian.revision.kweb.config.HUColors
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.core.App
import com.varabyte.kobweb.silk.SilkApp
import com.varabyte.kobweb.silk.components.layout.Surface
import org.jetbrains.compose.web.css.*

@App
@Composable
fun AppEntry(content: @Composable () -> Unit) {
    SilkApp {
        Surface(Modifier.minHeight(100.vh).fillMaxSize().background(HUColors.background)) {
            content()
        }
    }
}
